import { render, staticRenderFns } from "./CustomHTML.vue?vue&type=template&id=81fd9abe&"
import script from "./CustomHTML.vue?vue&type=script&lang=js&"
export * from "./CustomHTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports